import React, {Component} from "react";
import {DashboardSingleValueCell} from "../base/DashboardSingleValueCell";

export class DashboardFullPeriodYesterdayCell extends Component {
    render() {
        return <DashboardSingleValueCell status={this.props.data.status} value={this.props.data.formatted_value} rowType={this.props.rowType} />;
    }
}
